/***************************************************/
/******* CUSTOM SCRIPT FOR BELT BESPOKE PAGE *******/
/***************************************************/

/* Associated to template/product.belt-bespoke.liquid */

// ---------------------------
// ----- HTML References -----
// ---------------------------
const { qs, qsa } = window.BeltCustomizerCore;
const canvasBelt = document.getElementById("canvas-belt");
const canvasWorn = document.getElementById("canvas-worn");
const options = qsa('.option');

// ----------------------------
// ----- Constant sources -----
// ----------------------------
const pantsSrc = "https://cdn.shopify.com/s/files/1/0894/4094/4465/files/1400px-base-pantalon.jpg?v=1762936339"

// ---------------------------------------
// ----- Mobile vertical scroll hint -----
// ---------------------------------------
function bootMobileScrollHint() {
  function start() {
    const controls = document.getElementById('controls-container');
    if (!controls) return;

    let hint = document.getElementById('scroll-hint');

    if (!hint) {
      hint = document.createElement('div');
      hint.id = 'scroll-hint';
      hint.setAttribute('aria-hidden', 'true');
      hint.innerHTML = '<span>⌄</span>';
      controls.appendChild(hint);
    }

    function setImportant(element, property, value) {
      element.style.setProperty(property, value, 'important');
    }

    setImportant(hint, 'display', 'block');
    setImportant(hint, 'position', 'absolute');
    setImportant(hint, 'left', '0');
    setImportant(hint, 'right', '0');
    setImportant(hint, 'bottom', '60px');
    setImportant(hint, 'height', '52px');
    setImportant(hint, 'z-index', '999');
    setImportant(hint, 'pointer-events', 'none');
    setImportant(
      hint,
      'background',
      'linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,.98))'
    );
    setImportant(
      hint,
      'transition',
      'opacity .2s ease, visibility .2s ease'
    );

    const arrow = hint.querySelector('span');

    setImportant(arrow, 'position', 'absolute');
    setImportant(arrow, 'left', '50%');
    setImportant(arrow, 'bottom', '10px');
    setImportant(arrow, 'transform', 'translateX(-50%)');
    setImportant(arrow, 'font-size', '26px');
    setImportant(arrow, 'line-height', '1');
    setImportant(arrow, 'color', '#555');

    if (arrow.animate) {
      arrow.animate(
        [
          {
            transform: 'translateX(-50%) translateY(0)',
            opacity: 0.45
          },
          {
            transform: 'translateX(-50%) translateY(6px)',
            opacity: 1
          },
          {
            transform: 'translateX(-50%) translateY(0)',
            opacity: 0.45
          }
        ],
        {
          duration: 1300,
          iterations: Infinity,
          easing: 'ease-in-out'
        }
      );
    }

    function getActiveStep() {
      const activeSteps = Array.from(
        controls.querySelectorAll('.step.active')
      );

      return (
        activeSteps.find(step => step.style.zIndex === '2') ||
        activeSteps[activeSteps.length - 1] ||
        null
      );
    }

    function findScroller(step) {
      if (!step) return null;

      return (
        step.clientHeight > 0 &&
        step.scrollHeight > step.clientHeight + 4
      )
        ? step
        : null;
    }

    function refreshScrollHint() {
      const mobile = window.matchMedia(
        '(max-width: 768px)'
      ).matches;

      const step = getActiveStep();
      const scroller = findScroller(step);

      const hasManyOptions =
        step && step.querySelectorAll('.option').length > 4;

      const moreContentBelow = scroller
        ? scroller.scrollTop + scroller.clientHeight <
          scroller.scrollHeight - 6
        : hasManyOptions;

      const show = Boolean(
        mobile &&
        step &&
        moreContentBelow
      );

      setImportant(
        hint,
        'opacity',
        show ? '1' : '0'
      );

      setImportant(
        hint,
        'visibility',
        show ? 'visible' : 'hidden'
      );
    }

    /*
     * Scroll events do not normally bubble.
     * Capture mode catches scrolling from nested elements.
     */
    controls.addEventListener(
      'scroll',
      refreshScrollHint,
      true
    );

    window.addEventListener(
      'resize',
      refreshScrollHint,
      { passive: true }
    );

    const observer = new MutationObserver(() => {
      requestAnimationFrame(refreshScrollHint);
    });

    observer.observe(controls, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });

    requestAnimationFrame(refreshScrollHint);
    setTimeout(refreshScrollHint, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }
}
/* The class-driven hint below replaces the older injected hint. */

// -----------------------
// ----- Canvas size -----
// -----------------------

function fitToContainer(canvas) {
  window.BeltCustomizerCore.fitCanvas(canvas);
}

function initCanvas() {
  const canvasList = [canvasBelt, canvasWorn];
  const observer = new ResizeObserver(() => {
    canvasList.forEach(c => fitToContainer(c));
    renderPreview(previewState);
  });
  canvasList.forEach(c => observer.observe(c.parentElement));
}

// ------------------------
// ------- Tooltips -------
// ------------------------

function initTooltips() {
  const tooltip = document.getElementById('tooltip-global');

  qsa('.tooltip-wrapper').forEach(wrapper => {
    wrapper.addEventListener('mouseenter', () => {
      const content = wrapper.querySelector('.tooltip-content').innerHTML;
      const rect = wrapper.getBoundingClientRect();

      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const scrollLeft = window.scrollX || document.documentElement.scrollLeft;

      tooltip.innerHTML = content;
      tooltip.style.top = `0px`; // temporary
      tooltip.style.display = 'block';
      tooltip.style.opacity = '0';

      const halfWidth = tooltip.offsetWidth / 2;
      const center = rect.left + rect.width / 2;
      const visibleCenter = Math.max(halfWidth + 12,
        Math.min(center, window.innerWidth - halfWidth - 12));
      tooltip.style.left = `${visibleCenter + scrollLeft}px`;

      // Wait for DOM to paint the content and measure it
      requestAnimationFrame(() => {
        const tooltipHeight = tooltip.offsetHeight;
        tooltip.style.top = `${rect.top + scrollTop - tooltipHeight - 10}px`;
        tooltip.style.opacity = '1';
      });
    });

    wrapper.addEventListener('mouseleave', () => {
      tooltip.style.display = 'none';
      tooltip.style.opacity = '0';
    });
  });
}

// ------------------------
// -------- Modals --------
// ------------------------

function initModals() {
  const openBtns = qsa(".open-modal");

  openBtns.forEach(function(openBtn) {
    openBtn.addEventListener("click", () => {
      const modal = qs(openBtn.dataset.src);
      const closeBtn = modal.querySelector(".custom-modal__close");
      const overlay = modal.querySelector(".custom-modal__overlay");
      modal.style.display = "block";

      closeBtn.addEventListener("click", () => {
        modal.style.display = "none";
      });

      overlay.addEventListener("click", () => {
        modal.style.display = "none";
      });
    });
  });
}

// -----------------------------------
// ----- Asnychrone image loader -----
// -----------------------------------
const imageCache = new Map();

function loadImage(src) {
  if (src.startsWith('//')) src = 'https:' + src;
  if (imageCache.has(src)) return imageCache.get(src);

  const request = new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      resolve(img);
    };
    img.onerror = () => {
      console.error('Failed to load:', src);
      imageCache.delete(src);
      reject(new Error(`Failed to load ${src}`));
    };
    img.src = src;
  });

  imageCache.set(src, request);
  return request;
}

// -----------------------------
// ----- Preview rendering -----
// -----------------------------

let previewState = {
  leatherRecto: default_leather_recto_category + " / " + default_leather_recto_name,
  leatherVerso: default_leather_verso_category + " / " + default_leather_verso_name,
  threadsRecto: default_threads_recto,
  threadsVerso: default_threads_verso,
  edge: default_edge,
  face: "recto",     // could be user toggle or device-responsive
  buckle: "JH / Palladium",     // default buckle,
  initials: false,
  initialsColor: "neutral", // fallback color
  initialsLetters: null,  // store the string, null if none
  initialsPosition: "visible",  // store the string, null if none
  initialsPoints: "With points",  // store the string, null if none
}

function drawScaled(ctx, img, canvas) {
  ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, canvas.width, canvas.height);
}

function initPreviewState() {
  /**
   * Populates previewState with selected options in the UI
   */

  const leather_recto_category = qs('#step-leather-recto .option.active').dataset.leatherCategory;
  const leather_recto_name = qs('#step-leather-recto .option.active').dataset.leatherName;

  const leather_verso_category = qs('#step-leather-verso .option.active').dataset.leatherCategory;
  const leather_verso_name = qs('#step-leather-verso .option.active').dataset.leatherName;

  const threads_recto_name = qs('#step-threads-recto .option.active').dataset.threadsName;
  const threads_verso_name = qs('#step-threads-verso .option.active').dataset.threadsName;
  
  const edge_name = qs('#step-edge .option.active').dataset.edgeName;

  const buckle_category = qs('#step-buckle .option.active').dataset.buckleCategory;
  const buckle_name = qs('#step-buckle .option.active').dataset.buckleName;
  const face = qs('.rectoverso div.active').dataset.face;

  previewState.leatherRecto = leather_recto_category + ' / ' + leather_recto_name;
  previewState.leatherVerso = leather_verso_category + ' / ' + leather_verso_name;
  previewState.threadsRecto = threads_recto_name;
  previewState.threadsVerso = threads_verso_name;
  previewState.edge = edge_name;
  previewState.buckle = qs('#step-buckle .option.active').dataset.configNone === 'true'
    ? null : buckle_category + ' / ' + buckle_name;
  previewState.face = face;
}

let previewRequestId = 0;

async function renderPreview(state) {
  /**
    * Renders the preview for both the sole belt and the belt worn by the model.
    */

  const requestId = ++previewRequestId;
  canvasBelt.style.opacity = 0.3;
  canvasWorn.style.opacity = 0.3;

  if(typeof state.leatherRecto == 'undefined' || typeof state.leatherVerso == 'undefined' || typeof state.face == 'undefined') { return; }

  // Swap recto and verso when the user selects the other view
  let faceRecto = 'recto';
  let faceVerso = 'verso';
  if(state.face == 'verso') {
    faceRecto = 'verso';
    faceVerso = 'recto';
  }

  const buckleSources = state.buckle ? window.overlays.buckles[state.buckle] : null;
  const [
    leatherRecto, leatherVerso, leatherRecto_worn, leatherVerso_worn,
    threadsRecto, threadsVerso, threadsRecto_worn, threadsVerso_worn,
    edge, edge_worn, buckle, buckle_worn, model, shadow
  ] = await Promise.all([
    loadImage(window.overlays.leathers[state.leatherRecto][faceRecto]),
    loadImage(window.overlays.leathers[state.leatherVerso][faceVerso]),
    loadImage(window.overlays.leathers[state.leatherRecto]["worn_" + faceRecto]),
    loadImage(window.overlays.leathers[state.leatherVerso]["worn_" + faceVerso]),
    loadImage(window.overlays.threads[state.threadsRecto][faceRecto]),
    loadImage(window.overlays.threads[state.threadsVerso][faceVerso]),
    loadImage(window.overlays.threads[state.threadsRecto]["worn_" + faceRecto]),
    loadImage(window.overlays.threads[state.threadsVerso]["worn_" + faceVerso]),
    loadImage(window.overlays.edges[state.edge].alone),
    loadImage(window.overlays.edges[state.edge].worn),
    buckleSources ? loadImage(buckleSources.alone) : Promise.resolve(null),
    buckleSources ? loadImage(buckleSources.worn) : Promise.resolve(null),
    loadImage(window.overlays.model),
    loadImage(window.overlays.shadow_belt)
  ]);

  if (requestId !== previewRequestId) return;


  // Belt only preview
  const ctxBelt = canvasBelt.getContext("2d");
  ctxBelt.clearRect(0, 0, canvasBelt.width, canvasBelt.height);
  drawScaled(ctxBelt, shadow, canvasBelt);
  drawScaled(ctxBelt, leatherRecto, canvasBelt);
  drawScaled(ctxBelt, leatherVerso, canvasBelt);
  drawScaled(ctxBelt, threadsRecto, canvasBelt);
  drawScaled(ctxBelt, threadsVerso, canvasBelt);
  drawScaled(ctxBelt, edge, canvasBelt);

  if(state.buckle) {
    drawScaled(ctxBelt, buckle, canvasBelt);
  }

  // Worn preview
  const ctxWorn = canvasWorn.getContext("2d");
  ctxWorn.clearRect(0, 0, canvasWorn.width, canvasWorn.height);
  ctxWorn.drawImage(model, 0, 0, canvasWorn.width, canvasWorn.height);
  ctxWorn.drawImage(edge_worn, 0, 0, canvasWorn.width, canvasWorn.height);
  if(state.face == 'recto') {
    ctxWorn.drawImage(leatherRecto_worn, 0, 0, canvasWorn.width, canvasWorn.height);
    ctxWorn.drawImage(threadsRecto_worn, 0, 0, canvasWorn.width, canvasWorn.height);
  }
  else {
    ctxWorn.drawImage(leatherVerso_worn, 0, 0, canvasWorn.width, canvasWorn.height);
    ctxWorn.drawImage(threadsVerso_worn, 0, 0, canvasWorn.width, canvasWorn.height);
  }

  if(state.buckle) {
    ctxWorn.drawImage(buckle_worn, 0, 0, canvasWorn.width, canvasWorn.height);
  }

  // shearX, shearY, angleZ
  const angles = {
    'belt': {
      'visible': [Math.tan(-4 * Math.PI / 180), Math.tan(6 * Math.PI / 180), 6 * Math.PI / 180],
      'hidden': [Math.tan(30 * Math.PI / 180), Math.tan(-35 * Math.PI / 180), 10 * Math.PI / 180],
    },
    'worn': {
      'visible': [Math.tan(-2 * Math.PI / 180), Math.tan(3 * Math.PI / 180), 2 * Math.PI / 180],
    }
  };
  const size_ratios = {
    'belt': {
      'visible': 0.045,
      'hidden': 0.043,
    },
    'worn': {
      'visible': 0.032,
    },
  };
  // x,y
  const position_ratios = {
    'belt': {
      'visible': [0.20, 0.66],
      'hidden': [0.64, 0.47],
    },
    'worn': {
      'visible': [0.34, 0.56],
    },
  };

  const drawInitials = async (ctx, canvas, angles, size_ratio, position_ratio, bg_image_url = null) => {

    const fontSize = canvas.width * size_ratio;
    const x = Math.round(canvas.width * position_ratio[0]);
    const y = Math.round(canvas.height * position_ratio[1]);

    ctx.save();

    // === Transform for 3D effect ===
    ctx.translate(x, y);
    ctx.rotate(angles[2]);
    ctx.transform(1, angles[1], angles[0], 1, 0, 0);

    // === Create image pattern and apply to text ===
    ctx.font = `${fontSize}px serif`;
    ctx.textBaseline = 'middle';

    let initialsText = state.initialsLetters;
    if(state.initialsPoints.includes('With points') || state.initialsPoints.includes('Avec')) {
      initialsText = initialsText.split('').join('.') + '.';
    }

    if (bg_image_url) {
      try {
        const bg = await loadImage('https:' + bg_image_url);
        const pattern = ctx.createPattern(bg, 'repeat');
        ctx.fillStyle = pattern;
        ctx.fillText(initialsText, 0, 0);
      } catch (err) {
        console.warn("Pattern image failed to load:", 'https:' + bg_image_url);
      }
    } else {
      // Transparent fill + black outline fallback
      ctx.fillStyle = 'rgba(0, 0, 0, 0.25)'; // subtle black with 15% opacity
      ctx.fillText(initialsText, 0, 0);
    }

    ctx.restore();

  };

  // If the user entered initials and the preview is selected on recto, we display the initials
  if (state.initials && state.initialsLetters && state.face == 'recto') {
    const bg_image_url = qs('#initials-details .initials-color .option.active').dataset.bgImage;
    if(state.initialsPosition.toLowerCase().includes('visible')) {
      drawInitials(ctxBelt, canvasBelt, angles['belt']['visible'], size_ratios['belt']['visible'], position_ratios['belt']['visible'], bg_image_url);
      drawInitials(ctxWorn, canvasWorn, angles['worn']['visible'], size_ratios['worn']['visible'], position_ratios['worn']['visible'], bg_image_url);
    }
    else {
      drawInitials(ctxBelt, canvasBelt, angles['belt']['hidden'], size_ratios['belt']['hidden'], position_ratios['belt']['hidden'], bg_image_url);
    }
  }

  canvasBelt.style.opacity = 1;
  canvasWorn.style.opacity = 1;

}

// -------------------------
// ----- Step selector -----
// -------------------------

const mandatorySteps = [5, 6]; // 5: Buckle, 6: Size (0-indexed)

let currentStepIndex = 0;

let isTransitioning = false; // lock flag
let queuedStepNavigation = null;

const stepTitle = qs('.step-progress .step-title');
const stepCount = qs('.step-progress .step-count');

const recapItems = qsa('.recap-item');

// Dynamically get all visible steps in DOM order
const stepElements = Array.from(qsa('.step'));
const stepsCount = stepElements.length;

const visitedSteps = new Set();
visitedSteps.add(0);

const stepTitleElements = Array.from(document.querySelectorAll('.step-title-nav'));

function navigateToStep(nextIndex, direction) {
  if (nextIndex < 0 || nextIndex >= stepsCount) {
    return false;
  }

  if (isTransitioning) {
    if (nextIndex !== currentStepIndex) {
      queuedStepNavigation = { nextIndex, direction };
    }
    return false;
  }

  if (nextIndex === currentStepIndex) return false;

  currentStepIndex = nextIndex;
  updateStepDisplay(direction);
  return true;
}

function initSwipeNavigation() {
  BeltCustomizerCore.initStepSwipeNavigation(qs('#controls-container'), direction => {
    navigateToStep(
      currentStepIndex + (direction === 'next' ? 1 : -1),
      direction
    );
  });
}

function initBespokeScrollHints() {
  const steps = qsa('#controls-container .step');
  const hint = qs('#scroll-hint');
  const paletteStepIds = new Set([
    'step-leather-recto',
    'step-leather-verso',
    'step-threads-recto',
    'step-threads-verso',
    'step-edge'
  ]);

  const activeScrollableStep = () => steps.find(step =>
    step.classList.contains('active') &&
    step.scrollHeight > step.clientHeight + 4
  );

  if (hint) {
    const pageLanguage = (document.documentElement.lang || '').toLowerCase();
    hint.setAttribute('role', 'button');
    hint.setAttribute(
      'aria-label',
      pageLanguage.startsWith('fr') ? 'Afficher plus d’options' : 'Show more options'
    );
    hint.setAttribute('aria-hidden', 'true');
    hint.tabIndex = -1;

    const scrollActiveStep = event => {
      if (event) event.preventDefault();
      const step = activeScrollableStep();
      if (!step) return;
      step.scrollBy({
        top: Math.max(120, Math.round(step.clientHeight * 0.65)),
        behavior: 'smooth'
      });
    };

    hint.addEventListener('click', scrollActiveStep);
    hint.addEventListener('keydown', event => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      scrollActiveStep(event);
    });
  }

  function refresh() {
    const mobile = window.matchMedia('(max-width: 768px)').matches;
    const controls = qs('#controls-container');
    const recap = qs('#recap-bar');
    if (!mobile && controls) {
      const bounds = controls.getBoundingClientRect();
      const bottom = Math.min(bounds.bottom, window.innerHeight,
        recap ? recap.getBoundingClientRect().top : window.innerHeight);
      controls.style.setProperty('--palette-scroll-height', `${Math.max(0, bottom - bounds.top)}px`);
      if (hint) hint.style.bottom = `${Math.max(0, bounds.bottom - bottom)}px`;
    } else if (hint) {
      hint.style.removeProperty('bottom');
    }
    steps.forEach(step => {
      const isEligible = mobile || paletteStepIds.has(step.id);

      const canScrollDown = isEligible &&
        step.classList.contains('active') &&
        step.scrollHeight > step.clientHeight + 4 &&
        step.scrollTop + step.clientHeight < step.scrollHeight - 6;
      step.classList.toggle('show-scroll-hint', Boolean(canScrollDown));
    });
    if (hint) {
      const show = steps.some(step => step.classList.contains('show-scroll-hint'));
      hint.classList.toggle('visible', show);
      hint.setAttribute('aria-hidden', show ? 'false' : 'true');
      hint.tabIndex = show ? 0 : -1;
    }
  }

  steps.forEach(step => step.addEventListener('scroll', refresh, { passive: true }));
  window.addEventListener('resize', refresh, { passive: true });
  window.addEventListener('scroll', refresh, { passive: true });
  const layoutObserver = new ResizeObserver(() => requestAnimationFrame(refresh));
  [qs('#controls-container'), qs('#recap-bar'), ...qsa('#controls-container .step-row')]
    .filter(Boolean).forEach(element => layoutObserver.observe(element));
  if (document.fonts) document.fonts.ready.then(refresh);

  const observer = new MutationObserver(() => requestAnimationFrame(refresh));
  steps.forEach(step => observer.observe(step, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true
  }));

  requestAnimationFrame(refresh);
}

function updateStepNavigationUI() {
  stepTitleElements.forEach((el, index) => {
    const wrapper = el.closest('.step-title-wrapper');
    el.classList.toggle('active', index === currentStepIndex);
    if (wrapper) wrapper.classList.toggle('active', index === currentStepIndex);
  });

  if (window.matchMedia('(max-width: 768px)').matches) {
    BeltCustomizerCore.centerMobileStepNavigation();
    return;
  }

  const container = document.querySelector('.step-nav-titles');
  const el = stepTitleElements[currentStepIndex];

  if (!container || !el) return;

  const elRect = el.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();

  const offset =
    (elRect.left + elRect.width / 2) -
    (containerRect.left + containerRect.width / 2);

  container.style.transform = `translateX(${-offset}px)`;

}

let stepNavigationRefreshFrame = 0;

function refreshStepNavigationPosition() {
  cancelAnimationFrame(stepNavigationRefreshFrame);
  stepNavigationRefreshFrame = requestAnimationFrame(() => {
    stepNavigationRefreshFrame = requestAnimationFrame(updateStepNavigationUI);
  });
}

stepTitleElements.forEach((el, i) => {
  el.addEventListener('click', () => {
    navigateToStep(i, i > currentStepIndex ? 'next' : 'prev');
  });
});

/* Arrows on the sides on the titles */
function initArrowClickHandlers() {
  qsa('.nav-arrow').forEach(arrow => {
    arrow.removeEventListener('click', handleArrowClick); // clean before rebind
    arrow.addEventListener('click', handleArrowClick);
  });
}

function handleArrowClick(e) {
  e.stopPropagation(); // prevent bubbling if needed
  const dir = e.currentTarget.dataset.dir;

  if (dir === 'prev') navigateToStep(currentStepIndex - 1, 'prev');
  if (dir === 'next') navigateToStep(currentStepIndex + 1, 'next');
}

// Categories tabs
function initTabs(divId) {
  const tabButtons = qsa(`#${divId} .tab-button`);
  const tabPanels = qsa(`#${divId} .tab-panel`);

  tabButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      const targetId = button.getAttribute('data-tab-target');

      // Remove active from all
      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabPanels.forEach(panel => panel.classList.remove('active'));

      // Activate current
      button.classList.add('active');
      qs(`#${divId} #${targetId}`).classList.add('active');
    });
  });
}

function firstMissingMandatoryStep() {
  for (const i of mandatorySteps) {
    if (!visitedSteps.has(i)) return i;
  }
  return null;
}

function focusInvalidStepInput(stepSelector, inputSelector, highlight = false, attempt = 0) {
  const step = qs(stepSelector);
  const input = qs(inputSelector);

  if (!step || !input) return;

  /* A requested step may itself be queued behind the current slide. */
  if (isTransitioning || !step.classList.contains('active')) {
    if (attempt < 30) {
      setTimeout(
        () => focusInvalidStepInput(stepSelector, inputSelector, highlight, attempt + 1),
        60
      );
    }
    return;
  }

  if (highlight) {
    input.classList.remove('input-error-zoom');
    void input.offsetWidth;
    input.classList.add('input-error-zoom');
  }

  input.focus({ preventScroll: true });
  input.scrollIntoView({ behavior: 'smooth', block: 'center' });
  input.reportValidity();
}

// Validate size + unvisited mandatory steps
function validateBeforeSubmit(e) {
  const missingMandatory = firstMissingMandatoryStep();
  if (missingMandatory !== null) {
    e.preventDefault();
    const dir = missingMandatory > currentStepIndex ? 'next' : 'prev';
    navigateToStep(missingMandatory, dir);
    return true;
  }
  
  const sizeInput = qs('#exact-size');
  const sizeInvalid = !sizeInput ||
    sizeInput.value.trim() === '' ||
    !sizeInput.checkValidity();

  if (sizeInvalid) {
    e.preventDefault();

    const sizeStepIndex = 6; // step-size
    const dir = sizeStepIndex > currentStepIndex ? 'next' : 'prev';

    navigateToStep(sizeStepIndex, dir);
    focusInvalidStepInput('#step-size', '#exact-size', true);
    return true;
  }

  const initialsToggle = qs('#toggle-initials');
  const initialsInput = qs('#initials-details .initials-letters input');
  const initialsInvalid = initialsToggle?.checked && (
    !initialsInput ||
    initialsInput.value.trim() === '' ||
    !initialsInput.checkValidity()
  );

  if (initialsInvalid) {
    e.preventDefault();

    const initialsStepIndex = stepElements.indexOf(qs('#step-initials'));
    const dir = initialsStepIndex > currentStepIndex ? 'next' : 'prev';

    navigateToStep(initialsStepIndex, dir);
    focusInvalidStepInput(
      '#step-initials',
      '#initials-details .initials-letters input'
    );

    return true;
  }

  return false;
}

qs('#recap-buy').addEventListener('click', validateBeforeSubmit);
qs('form[action*="/cart/add"]').addEventListener('submit', validateBeforeSubmit);


/** Utility: update visible step **/
function updateStepDisplay(direction = 'next') {
  if (isTransitioning) return;

  const allSteps = Array.from(qsa('.step'));
  const activeStep = allSteps.find(el => el.classList.contains('active'));
  const newStep = allSteps[currentStepIndex];

  if (!newStep || newStep === activeStep) {
    return;
  }

  isTransitioning = true;
  visitedSteps.add(currentStepIndex);

  // Clear previous animations
  allSteps.forEach(el => el.classList.remove('slide-out-left', 'slide-out-right'));

  const isNext = direction === 'next';

  // Place new step in correct start position
  newStep.classList.add('active');
  newStep.style.transition = 'none';
  newStep.style.transform = isNext ? 'translateX(100%)' : 'translateX(-100%)';
  newStep.style.opacity = '1';
  newStep.style.zIndex = '2';

  // Force reflow so the browser registers start position
  void newStep.offsetWidth;

  // Animate the current active step out
  if (activeStep) {
    activeStep.style.transition = 'transform 0.5s ease, opacity 0.5s ease';
    activeStep.style.zIndex = '1';
    activeStep.style.transform = isNext ? 'translateX(-100%)' : 'translateX(100%)';
  }

  // Animate the new step in
  newStep.style.transition = 'transform 0.5s ease';
  newStep.style.transform = 'translateX(0)';

  // Cleanup only the old one after animation completes
  setTimeout(() => {
    if (activeStep) activeStep.classList.remove('active');
    newStep.removeAttribute('style');
    isTransitioning = false; // Unlock

    if (queuedStepNavigation) {
      const queued = queuedStepNavigation;
      queuedStepNavigation = null;
      navigateToStep(queued.nextIndex, queued.direction);
    }
  }, 500);

  // Update title and counter

  // Update recap highlight
  recapItems.forEach((r, i) => r.classList.toggle('active', i === currentStepIndex));

  // Update arrows

  updateStepNavigationUI();
}

recapItems.forEach((item, i) => {
  item.addEventListener('click', () => {
    navigateToStep(i, i > currentStepIndex ? 'next' : 'prev');
  });
});



// -----------------------
// ------ Belt size ------
// -----------------------

qs('#exact-size').addEventListener('change', function() {
  updateRecap('size', this.value + 'cm');
});

// ----------------------------
// ----- Recap bottom bar -----
// ----------------------------

// Updates the recap bar given a key and a value
function updateRecap(key, value) {
    const toPascal = s =>
    s
      .trim()
      .split(/\s+/)
      .map(w => w.charAt(0).toUpperCase() + w.slice(1))
      .join('');

  const el = document.getElementById(`recap${toPascal(key)}`);
  if (el) el.textContent = value;
}

// Initializes the recap with keys for leathers, buckles, sizes and initials if available
function initRecap() {
  const active_leather_recto = qs('#step-leather-recto .option.active');
  const active_leather_verso = qs('#step-leather-verso .option.active');
  const active_threads_recto = qs('#step-threads-recto .option.active');
  const active_threads_verso = qs('#step-threads-verso .option.active');
  const active_edge = qs('#step-edge .option.active');
  const active_buckle = qs('#step-buckle .option.active');
  const exact_size = qs('#exact-size');

  if(!active_leather_recto || !active_leather_verso || !active_threads_recto || !active_threads_verso || !active_edge || !active_buckle) { return; }

  updateRecap('leather recto', active_leather_recto.dataset.displayName || active_leather_recto.dataset.leatherName);
  updateRecap('leather verso', active_leather_verso.dataset.displayName || active_leather_verso.dataset.leatherName);
  updateRecap('threads recto', active_threads_recto.dataset.displayName || active_threads_recto.dataset.threadsName);
  updateRecap('threads verso', active_threads_verso.dataset.displayName || active_threads_verso.dataset.threadsName);
  updateRecap('edge', active_edge.dataset.displayName || active_edge.dataset.edgeName);
  updateRecap('buckle', active_buckle.dataset.buckleName);
  updateRecap('size', exact_size && exact_size.value ? `${exact_size.value}cm` : '—');
}

function updatePrice() {
  const active_leather_recto = qs('#step-leather-recto .option.active') || qs('#step-leather-recto .option:not(.oos)');
  const active_leather_verso = qs('#step-leather-verso .option.active') || qs('#step-leather-verso .option:not(.oos)');
  const active_threads_recto = qs('#step-threads-recto .option.active') || qs('#step-threads-recto .option:not(.oos)');
  const active_threads_verso = qs('#step-threads-verso .option.active') || qs('#step-threads-verso .option:not(.oos)');
  const active_edge = qs('#step-edge .option.active') || qs('#step-edge .option:not(.oos)');
  const active_buckle = qs('#step-buckle .option.active') || qs('#step-buckle .option:not(.oos)');
  const active_initials = qs('#step-initials #toggle-initials');
  const price_span = qsa('#recap-bar .recap-price .amount');

  const pricedOptions = [active_leather_recto, active_leather_verso, active_threads_recto, active_threads_verso, active_edge, active_buckle];
  if (pricedOptions.some(option => !option) || !active_initials) return false;
  pricedOptions.forEach(option => option.classList.add('active'));

  let price = Math.round(
    (
      parseInt(active_leather_recto.dataset.price)
    + parseInt(active_leather_verso.dataset.price)
    + parseInt(active_threads_recto.dataset.price) // usually 0
    + parseInt(active_threads_verso.dataset.price) // usually 0
    + parseInt(active_edge.dataset.price) // usually 0
    + parseInt(active_buckle.dataset.price)
    ) / 100);

  if(active_initials.checked) {
    price = price + parseInt(active_initials.dataset.price) / 100;
  }

  if (!Number.isFinite(price)) return false;

  price_span.forEach((elem) => {
    elem.textContent = price;
  });

  return true;
}

// -----------------------------------------------------------
// ----- Handle active/inactive options and update recap -----
// -----------------------------------------------------------

// Allow only 1 active option at a time
options.forEach(opt => {
  opt.addEventListener('click', () => {
    // remove active from siblings
    const siblings = opt.closest('.exclusive-options').querySelectorAll('.option'); // Only one activable leather among all categories
    siblings.forEach(s => s.classList.remove('active'));

    // activate the clicked one
    opt.classList.add('active');
  });
});

// Update recap and preview after leather recto choice
qsa('#step-leather-recto .option[data-leather-name]').forEach(opt => {
  opt.addEventListener('click', () => {
    updateRecap('leather recto', opt.dataset.displayName || opt.dataset.leatherName);

    previewState.leatherRecto = opt.dataset.leatherCategory + ' / ' + opt.dataset.leatherName;
    renderPreview(previewState);
  });
});

// Update recap and preview after leather verso choice
qsa('#step-leather-verso .option[data-leather-name]').forEach(opt => {
  opt.addEventListener('click', () => {
    updateRecap('leather verso', opt.dataset.displayName || opt.dataset.leatherName);

    previewState.leatherVerso = opt.dataset.leatherCategory + ' / ' + opt.dataset.leatherName;
    renderPreview(previewState);
  });
});

// Update recap and preview after threads recto choice
qsa('#step-threads-recto .option[data-threads-name]').forEach(opt => {
  opt.addEventListener('click', () => {
    updateRecap('threads recto', opt.dataset.displayName || opt.dataset.threadsName);

    previewState.threadsRecto = opt.dataset.threadsName;
    renderPreview(previewState);
  });
});

// Update recap and preview after threads verso choice
qsa('#step-threads-verso .option[data-threads-name]').forEach(opt => {
  opt.addEventListener('click', () => {
    updateRecap('threads verso', opt.dataset.displayName || opt.dataset.threadsName);

    previewState.threadsVerso = opt.dataset.threadsName;
    renderPreview(previewState);
  });
});

// Update recap and preview after edge choice
qsa('#step-edge .option[data-edge-name]').forEach(opt => {
  opt.addEventListener('click', () => {
    updateRecap('edge', opt.dataset.displayName || opt.dataset.edgeName);

    previewState.edge = opt.dataset.edgeName;
    renderPreview(previewState);
  });
});

// Update recap and preview after buckle choice
qsa('#step-buckle .option[data-buckle-name]').forEach(opt => {
  opt.addEventListener('click', () => {
    updateRecap('buckle', opt.dataset.buckleName);

    if(opt.dataset.configNone !== 'true' && opt.dataset.buckleName != 'Without' && opt.dataset.buckleName != 'Sans') {
      previewState.buckle = opt.dataset.buckleCategory + ' / ' + opt.dataset.buckleName;
    }
    else {
      previewState.buckle = null;
    }
    renderPreview(previewState);
  });
});

// Update recap after size choice
qsa('.option[data-size]').forEach(opt => {
  opt.addEventListener('click', () => {
    const unit = qs('.unit-option.active').dataset.unit
    let size = opt.dataset.size
    if(unit == 'in') {
      size = Math.round(size / 2.54 * 10) / 10
    }
    const size_disp = size + unit
    updateRecap('size', size_disp)
  })
});

// Handle active/inactive unit in size selection
qsa('.unit-option').forEach(opt => {
  opt.addEventListener('click', () => {
    // Remove active from siblings
    const siblings = opt.closest('.unit-selector').querySelectorAll('.unit-option'); // Only one activable leather among all categories
    siblings.forEach(s => s.classList.remove('active'));

    // Activate the clicked one
    opt.classList.add('active');

    // Update recap
    const unit = qs('.unit-option.active').dataset.unit
    const selected_opt = qs('#step-size .option.active').dataset.size
    let size = selected_opt
    if(unit == 'in') {
      size = Math.round(size / 2.54 * 10) / 10
    }
    const size_disp = size + unit
    updateRecap('size', size_disp)

    // Change size display
    qsa('#size-options .option').forEach(opt => {
      if(unit == 'in') {
        opt.textContent = opt.dataset.inches;
      }
      else if(unit == 'cm') {
        opt.textContent = opt.dataset.size;
      }
    });
  });
});

// Update recap and preview after initials change
const updateInitialsState = () => {

  // Update preview
  const toggle = qs('#toggle-initials');
  const initialsLetters = qs('#initials-details .initials-letters input');
  const initialsColor = qs('#initials-details .initials-color .option.active');
  const initialsPosition = qs('#initials-details .initials-position .option.active');
  const initialsPoints = qs('#initials-details .initials-points select');

  previewState.initials = toggle.checked;
  previewState.initialsLetters = toggle.checked ? initialsLetters.value.toUpperCase().slice(0, 3) : null;
  previewState.initialsColor = initialsColor.dataset.color.toLowerCase();
  previewState.initialsPosition = initialsPosition.dataset.position;
  previewState.initialsPoints = initialsPoints.value;

  renderPreview(previewState);

  // Update recap
  let initials_disp = '—';
  if(toggle.checked && previewState.initialsLetters)
  {
    initials_disp = previewState.initialsLetters;
    if(previewState.initialsPoints) {
      initials_disp = initials_disp.split('').join('.') + '.';
    }
  }
  updateRecap('initials', initials_disp)
  updateBundleSelection();
};

qs('#toggle-initials').addEventListener('change', updateInitialsState);
qs('#initials-details .initials-letters input').addEventListener('input', updateInitialsState);
qsa('#initials-details .initials-color .option').forEach((opt) => opt.addEventListener('click', updateInitialsState));
qsa('#initials-details .initials-position .option').forEach((opt) => opt.addEventListener('click', updateInitialsState));
qs('#initials-details .initials-points select').addEventListener('input', updateInitialsState);

qs('#initials-details .initials-letters input').addEventListener('keydown', (e) => {
  if (e.key === 'Enter') {
    e.preventDefault();
  }
});

// ------------------------------------------
// ------ Tone on tone buttons handler ------
// ------------------------------------------

qs('#tone-on-tone-recto').addEventListener('change', function() {
  if(this.checked) {
    const leather_color_recto = qs('#step-leather-recto .option.active').dataset.leatherName;
    const matching_threads = qs(`#step-threads-recto .option[data-threads-name="${leather_color_recto}"]`)
    // Set the matching thread as active
    matching_threads.click();
  }
});

qs('#tone-on-tone-verso').addEventListener('change', function() {
  if(this.checked) {
    const leather_color_verso = qs('#step-leather-verso .option.active').dataset.leatherName;
    const matching_threads = qs(`#step-threads-verso .option[data-threads-name="${leather_color_verso}"]`)
    // Set the matching thread as active
    matching_threads.click();
  }
});

// On leather/threads change, check if whether it is tone on tone
qsa('.leather-row .option, .threads-row .option').forEach(opt => {
  opt.addEventListener('click', function() {
    // Recto
    const leather_color_recto = qs('#step-leather-recto .option.active').dataset.leatherName;
    const matching_threads_recto = qs(`#step-threads-recto .option[data-threads-name="${leather_color_recto}"]`)
    const selected_threads_recto = qs('#step-threads-recto .option.active');

    qs('#tone-on-tone-recto').checked = false;
    if(selected_threads_recto == matching_threads_recto) {
      qs('#tone-on-tone-recto').checked = true;
    }

    // Verso
    const leather_color_verso = qs('#step-leather-verso .option.active').dataset.leatherName;
    const matching_threads_verso = qs(`#step-threads-verso .option[data-threads-name="${leather_color_verso}"]`)
    const selected_threads_verso = qs('#step-threads-verso .option.active');

    qs('#tone-on-tone-verso').checked = false;
    if(selected_threads_verso == matching_threads_verso) {
      qs('#tone-on-tone-verso').checked = true;
    }
  });
});

// ------------------------------------------
// ----- Form / Bundle selection update -----
// ------------------------------------------

// Updates the hidden form according to the selected variants
function updateBundleSelection() {
  const active_leather_recto = qs('#step-leather-recto .option.active');
  const active_leather_verso = qs('#step-leather-verso .option.active');
  const active_threads_recto = qs('#step-threads-recto .option.active');
  const active_threads_verso = qs('#step-threads-verso .option.active');
  const active_edge = qs('#step-edge .option.active');
  const active_buckle = qs('#step-buckle .option.active');
  const active_size = qs('#step-size .option.active');
  
  const active_initials = qs('#step-initials #toggle-initials');
  const initials_letters = qs('#step-initials .initials-letters input');
  const initials_points = qs('#step-initials .initials-points select');
  const initials_color = qs('#step-initials .initials-color .option.active');
  const initials_position = qs('#step-initials .initials-position .option.active');

  // const line_item = qs('input[name="properties[Initials]"]');

  if (
    !active_leather_recto ||
    !active_leather_verso ||
    !active_threads_recto ||
    !active_threads_verso ||
    !active_edge ||
    !active_buckle
  ) return false;

  const input_bundle_selection = qs("input[name='properties[_bundle_selection]']");
  const initials_enabled = Boolean(active_initials?.checked);
  const initials_color_value = initials_color?.dataset.color || 'silver';
  const initials_position_value = initials_position?.dataset.position || '';
  const initials_points_value = initials_points?.value || '';
  const initials_letters_value = (initials_letters?.value || '').toUpperCase();

  // Handle initials value
  const initials_prefix = 'Initials - ';
  const initials_value = initials_prefix + initials_color_value + ' / ' + initials_position_value + ' / ' + initials_points_value;

  if (input_bundle_selection) {
    input_bundle_selection.value = active_leather_recto.dataset.variantName + ' <> ' + active_leather_verso.dataset.variantName + ' <> ' + active_threads_recto.dataset.variantName + ' <> ' + active_threads_verso.dataset.variantName + ' <> ' + active_edge.dataset.variantName + ' <> ' + active_buckle.dataset.variantName;
  }
  if (input_bundle_selection && initials_enabled) {
    input_bundle_selection.value = input_bundle_selection.value + ' <> ' + initials_value;
    // let letters = initials_letters.value.toUpperCase();
    // if(initials_points.value.includes('With points') || initials_points.value.includes('Avec')) {
    //   letters = letters.split('').join('.') + '.'
    // }
    // line_item.value = letters;
  }

  const setCartProperty = (key, value) => {
    const input = qs(`[data-cart-property="${key}"]`);
    if (input) input.value = value || '';
  };

  setCartProperty('leather-recto', active_leather_recto.dataset.variantName || `${active_leather_recto.dataset.leatherCategory} / ${active_leather_recto.dataset.leatherName}`);
  setCartProperty('leather-verso', active_leather_verso.dataset.variantName || `${active_leather_verso.dataset.leatherCategory} / ${active_leather_verso.dataset.leatherName}`);
  setCartProperty('thread-recto', active_threads_recto.dataset.variantName || active_threads_recto.dataset.threadsName);
  setCartProperty('thread-verso', active_threads_verso.dataset.variantName || active_threads_verso.dataset.threadsName);
  setCartProperty('edge', active_edge.dataset.variantName || active_edge.dataset.edgeName);
  setCartProperty('buckle', active_buckle.dataset.variantName || `${active_buckle.dataset.buckleCategory} / ${active_buckle.dataset.buckleName}`);
  setCartProperty(
    'initials',
    initials_enabled
      ? `${initials_letters_value} / ${initials_color_value} / ${initials_position_value} / ${initials_points_value}`
      : ''
  );

  const leather_recto_key = `${active_leather_recto.dataset.leatherCategory} / ${active_leather_recto.dataset.leatherName}`;
  const leather_verso_key = `${active_leather_verso.dataset.leatherCategory} / ${active_leather_verso.dataset.leatherName}`;
  const buckle_key = `${active_buckle.dataset.buckleCategory} / ${active_buckle.dataset.buckleName}`;
  const initials_position_key = initials_position_value.toLowerCase().includes('visible') ? 'visible' : 'hidden';
  const initials_with_points = initials_points_value.includes('With points') || initials_points_value.includes('Avec');

  BeltCustomizerCore.syncCartPreview({
    root: qs('#customizer'),
    mode: 'bespoke',
    layers: [
      window.overlays?.shadow_belt,
      window.overlays?.leathers?.[leather_recto_key]?.recto,
      window.overlays?.leathers?.[leather_verso_key]?.verso,
      window.overlays?.threads?.[active_threads_recto.dataset.threadsName]?.recto,
      window.overlays?.threads?.[active_threads_verso.dataset.threadsName]?.verso,
      window.overlays?.edges?.[active_edge.dataset.edgeName]?.alone,
      window.overlays?.buckles?.[buckle_key]?.alone
    ],
    initials: {
      letters: initials_enabled ? initials_letters_value : '',
      withPoints: initials_enabled && initials_with_points,
      position: initials_enabled ? initials_position_key : '',
      texture: initials_enabled ? (initials_color?.dataset.bgImage || '') : ''
    }
  });

  return true;
}

qsa('.option').forEach(opt => { opt.addEventListener('click', () => {
  updatePrice();
  updateBundleSelection();
}) });

const bespokeProductForm = qs('#customizer form[action*="/cart/add"]');
if (bespokeProductForm) {
  bespokeProductForm.addEventListener('submit', updateBundleSelection, { capture: true });
  BeltCustomizerCore.bindCartSubmit({
    form: bespokeProductForm,
    root: qs('#customizer'),
    beforeSubmit: validateBeforeSubmit,
    syncProperties: updateBundleSelection
  });
}

// Recto-verso selector
qsa('.rectoverso div').forEach(btn => { btn.addEventListener('click', () => {
  const face = btn.dataset.face;
  previewState.face = face;
  qsa('.rectoverso div').forEach(div => {
    div.classList.remove('active');
  });
  btn.classList.add('active');
  renderPreview(previewState);
}) });

// View selector (on mobile)
qsa('.beltworn div').forEach(btn => { btn.addEventListener('click', () => {
  const preview = btn.dataset.preview;
  qsa('.beltworn div').forEach(div => {
    div.classList.remove('active');
  });
  btn.classList.add('active');
  
  qsa('.preview-wrapper').forEach(div => {
    div.classList.remove('active');
  });
  qs('#preview-' + preview).classList.add('active');
}) });


/** Initialize **/
let beltBespokeInitialized = false;

function runBespokeInitTask(name, task) {
  try {
    task();
  } catch (error) {
    console.error(`Belt bespoke initialization failed at: ${name}`, error);
  }
}

function selectAvailableBespokeDefaults() {
  for (const id of ['step-leather-recto', 'step-leather-verso', 'step-threads-recto', 'step-threads-verso', 'step-edge', 'step-buckle']) {
    const choices = qsa(`#${id} .option`);
    const available = option => !option.classList.contains('oos') && option.dataset.available !== 'false';
    const selected = choices.find(option => option.classList.contains('active') && available(option)) || choices.find(available);
    choices.forEach(option => option.classList.toggle('active', option === selected));
    const panel = selected?.closest('.tab-panel');
    if (panel) qsa(`#${id} .tab-button`).find(button => button.dataset.tabTarget === panel.id)?.click();
  }
}

function initBeltBespoke() {
  if (beltBespokeInitialized || !qs('#customizer')) return;
  beltBespokeInitialized = true;

  /* Critical UI is initialized first and cannot be blocked by preview data. */
  runBespokeInitTask('first step', () => {
    stepElements.forEach((step, index) => step.classList.toggle('active', index === 0));
    currentStepIndex = 0;
    updateStepNavigationUI();
  });
  runBespokeInitTask('arrow navigation', initArrowClickHandlers);
  runBespokeInitTask('step swipe', initSwipeNavigation);
  runBespokeInitTask('scroll hints', initBespokeScrollHints);
  runBespokeInitTask('step display', () => updateStepDisplay());
  runBespokeInitTask('default initials color', () => BeltCustomizerCore.selectDefaultInitialsColor(qs('#customizer')));
  runBespokeInitTask('initial price', updatePrice);
  runBespokeInitTask('modals', initModals);

  runBespokeInitTask('canvas', () => {
    initCanvas();
    fitToContainer(canvasBelt);
    fitToContainer(canvasWorn);
  });
  runBespokeInitTask('recto tabs', () => initTabs('step-leather-recto'));
  runBespokeInitTask('verso tabs', () => initTabs('step-leather-verso'));
  runBespokeInitTask('available defaults', selectAvailableBespokeDefaults);
  runBespokeInitTask('available price', updatePrice);
  runBespokeInitTask('preview state', initPreviewState);
  runBespokeInitTask('bundle selection', updateBundleSelection);
  runBespokeInitTask('preview render', () => renderPreview(previewState));
  runBespokeInitTask('recap', initRecap);
  runBespokeInitTask('tooltips', initTooltips);
  runBespokeInitTask('buckle horizontal scroll hint', () => {
    BeltCustomizerCore.initHorizontalScrollHint(qs('#customizer'));
  });

  runBespokeInitTask('initials visibility', () => {
    const toggle = qs('#toggle-initials');
    const details = qs('#initials-details');
    const letters = details && qs('.initials-letters input', details);
    if (!toggle || !details || !letters) return;
    toggle.addEventListener('change', () => {
      details.classList.toggle('hidden', !toggle.checked);
      letters.required = toggle.checked;
      updateBundleSelection();
      updatePrice();
    });
  });

  runBespokeInitTask('URL configuration', () => {
    BeltConfigURL.init(qs('#customizer'), {
      onSelected(field) {
        if (field === 'buckle') visitedSteps.add(5);
        if (field === 'size') visitedSteps.add(6);
      },
      onApplied() {
        updateInitialsState();
        initRecap();
        updatePrice();
        updateBundleSelection();
      }
    });
  });

  requestAnimationFrame(() => {
    runBespokeInitTask('navigation refresh', refreshStepNavigationPosition);
    refreshBespokePrice();
  });
}

function scheduleBeltBespokeInit() {
  if (qs('#customizer')) initBeltBespoke();
}

scheduleBeltBespokeInit();
document.addEventListener('DOMContentLoaded', scheduleBeltBespokeInit, { once: true });
window.addEventListener('load', scheduleBeltBespokeInit, { once: true });
window.addEventListener('load', refreshStepNavigationPosition, { once: true });
window.addEventListener('resize', refreshStepNavigationPosition, { passive: true });

if (document.fonts?.ready) {
  document.fonts.ready.then(refreshStepNavigationPosition);
}

function refreshBespokePrice(attempt = 0) {
  try {
    if (updatePrice()) return;
  } catch (error) {
    console.warn('Initial bespoke belt price is not ready yet.', error);
  }
  if (attempt < 10) setTimeout(() => refreshBespokePrice(attempt + 1), 100);
}

document.addEventListener('belt:initials-toggle', () => {
  updateInitialsState();
  updatePrice();
  updateBundleSelection();
});

requestAnimationFrame(() => refreshBespokePrice());
